export const isDev = process.env.NODE_ENV === 'development'
export const isStrictMode = process.env.REACT_APP_STRICT_MODE
export const adminApiBaseURL = process.env.REACT_APP_SAAS_ADMIN_API
export const systemApiBaseURL = process.env.REACT_APP_SAAS_SYSTEM_API
export const userApiBaseURL = process.env.REACT_APP_SAAS_USER_API
export const authApiBaseURL = process.env.REACT_APP_AUTH_API
export const packageApiBaseURL = process.env.REACT_APP_PACKAGE_API
export const themeApiBaseURL = process.env.REACT_APP_THEME_API
